// Presentation only: use the backend status, never infer severity from a title.
export function incidentState(status) {
  switch (String(status || "").trim().toLowerCase()) {
    case "active":
    case "active incident": return "active";
    case "outage": return "outage";
    case "resolved": return "resolved";
    default: return "unknown";
  }
}

export function incidentLabel(status) {
  const state = incidentState(status);
  return state === "unknown" ? status || "Unknown" : state[0].toUpperCase() + state.slice(1);
}

export function sortedIncidents(incidents) {
  return [...incidents].sort((a, b) =>
    Number(incidentState(a.Status) === "resolved") - Number(incidentState(b.Status) === "resolved")
    || (Date.parse(b.PublishDate) || 0) - (Date.parse(a.PublishDate) || 0)
    || Number(b.IncidentId) - Number(a.IncidentId));
}

export function incidentPreview(incidents, resolvedLimit = 5) {
  let resolved = 0;
  return sortedIncidents(incidents).filter(incident =>
    incidentState(incident.Status) !== "resolved" || resolved++ < resolvedLimit);
}

export function incidentText(html) {
  const document = new DOMParser().parseFromString(html || "", "text/html");
  document.querySelectorAll("script, style").forEach(node => node.remove());
  document.querySelectorAll("br").forEach(node => node.replaceWith("\n"));
  document.querySelectorAll("p, div, li").forEach(node => node.append("\n"));
  return document.body.textContent.trim();
}

export function incidentReportLink(link) {
  try {
    const url = new URL(link);
    return ["https:", "http:"].includes(url.protocol) ? url.href : null;
  } catch { return null; }
}
